import React from 'react'
import { CustomAccordion } from '../../components/Accordion';


const DataList = [
    {
        id: "1",
        summary: "About the Organization",
    },
    {
        id: "2",
        summary: "About the Event",
    },
    {
        id: "3",
        summary: "Audience",
    },
    {
        id: "4",
        summary: "Sponsors",
    },
];
function AboutClient() {
    return (
        <div>
            {DataList.map((cItem) => (
                <CustomAccordion
                    key={cItem.id}
                    view="v1"
                    gutterBottom
                    summary={cItem.summary}
                    details={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget."}
                ></CustomAccordion>
            ))}
        </div>
    );
}

export default AboutClient;
